<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t } = useI18n();
const route = useRoute();

const title = computed(() => t(`common.${route.meta?.title}`));

</script>
<template>
  <div class="page-head">
    <div class="page-head__title">
      <h1>{{ title }}</h1>
    </div>
    <ol class="page-head__breadcrumb">
      <!-- <li>
        <span class="page-head__breadcrumb--icon"></span>
        <span class="page-head__breadcrumb--text">홈</span>
      </li>
      <li>
        <span class="page-head__breadcrumb--text">{{ route.name }}</span>
      </li> -->
    </ol>
  </div>
</template>
